import { gql } from '@apollo/client'
import { ID } from '../IQueryData'
import {
  IBulkParkingPoolActionPayload,
  BULK_PARKING_POOL_ACTION_FIELDS,
} from './bulkParkingPoolAction'

export interface IBulkCancelParkingSubscriptionsForUserVars {
  parkingSubscriptions: ID[]
  comment: string
  notify: boolean
}

export interface IBulkCancelParkingSubscriptionsForUserData {
  bulkCancelParkingSubscriptionsForUser: IBulkParkingPoolActionPayload
}

export const BULK_CANCEL_PARKING_SUBSCRIPTIONS_FOR_USER = gql`
  mutation bulkCancelParkingSubscriptionsForUser(
    $parkingSubscriptions: [ID!]!
    $comment: String!
    $notify: Boolean
  ) {
    bulkCancelParkingSubscriptionsForUser(
      parking_subscriptions: $parkingSubscriptions
      comment: $comment
      notify: $notify
    ) {
      ${BULK_PARKING_POOL_ACTION_FIELDS}
    }
  }
`
